import { IReaction } from "../enum/constants.enum";
import { MessageResponse } from "../interfaces/messages";
import { IMessageList } from "../interfaces/types.interface";

export const transformMessageDtoToVm = (message: MessageResponse, sessionId: string): IMessageList => {
  return {
    id: message?.id,
    download_url: message?.csv_link || null,
    text: message.text,
    sender: message.sender_type,
    isError: false,
    reaction: message?.feedback
      ? message?.feedback?.score >= 4
        ? IReaction.good
        : IReaction.bad
      : '',
    comment: message?.feedback?.comment || '',
    feedbackId: message?.feedback?.id || '',
    isReaction: !!message?.feedback,
    session_id: sessionId,
    text_output: message?.text_output || null,
    reasoning: message?.reasoning ?? undefined,
  };
};
